import { CompanyProfile } from '@mkp/company/models';
import { ErrorState } from '@mkp/shared/util-state';
import { createActionGroup, props } from '@ngrx/store';

export const CompanyApiActions = createActionGroup({
  source: 'Company/API',
  events: {
    'Load Companies Success': props<{
      companies: CompanyProfile[];
      selectedId?: string | undefined;
    }>(),
    'Load Companies Failure': props<{ error: ErrorState }>(),
    'Refresh All Companies Success': props<{ companyProfiles: CompanyProfile[] }>(),
    'Refresh All Companies Failure': props<{ error: { message: string } }>(),
  },
});
